// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBo_dxRlbi0eL32dbpyLDK4XapyQKVj6hI",
  authDomain: "umth-pacs.firebaseapp.com",
  projectId: "umth-pacs",
  storageBucket: "umth-pacs.firebasestorage.app",
  messagingSenderId: "989672073601",
  appId: "1:989672073601:web:f333035c035013053ca080",
  measurementId: "G-0K94H95GK5"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);
const auth = getAuth(app);


export { firestore, auth };

